export const MIN_READING_PANE_WIDTH = 358;
export const RESPONSIVE_READING_PANE_WIDTH = 600;
export const MIN_PREVIEW_PANE_WIDTH = 600;
export const PREVIEW_PANE_WIDTH = 650;
export const READING_PANE_DEFAULT_PERCENT_SIZE: number = 100 * (1 / 2.89);
export const V2_MIN_READING_PANE_WIDTH = 420;
export const V2_READING_PANE_DEFAULT_PERCENT_SIZE: number = 100 * (420 / 1300);
